export const getCurrentStep = stepsStatuses => {
  if (!stepsStatuses.emailIsValid && !stepsStatuses.brokerNiceName) {
    return 1;
  }
  if (!stepsStatuses.dnsTxtIsValid || !stepsStatuses.dnsCnameIsValid) {
    if (!stepsStatuses.userDomain) {
      return 2;
    }

    return 3;
  }
  if (!stepsStatuses.mtIsValid) {
    return 4;
  }
  if (!stepsStatuses.crmSetup) {
    return 5;
  }

  return 6;
};
